import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Banknote } from "lucide-react";
import { Button } from "../ui/button";
import { payoutApi } from "../../lib/api";

// In-app nudge shown to drivers/restaurant owners who have no payout bank
// account on file yet, so their automatic weekly payout isn't missed.
export default function PayoutReminder() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    payoutApi.me().then((d) => setShow(!d.has_account)).catch(() => {});
  }, []);

  if (!show) return null;
  return (
    <div className="mb-6 flex flex-wrap items-center gap-4 rounded-2xl border border-amber-200 bg-amber-50 p-5" data-testid="payout-reminder-banner">
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-amber-600"><Banknote className="h-5 w-5" /></span>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-ink">Add your bank details to get paid</p>
        <p className="text-sm text-ink-soft">Your earnings are paid out automatically every Wednesday (for the Monday–Sunday week) — but only once we have your bank account on file.</p>
      </div>
      <Button asChild className="rounded-full bg-brand text-white hover:bg-brand-600"><Link to="/app/payouts" data-testid="payout-reminder-link">Add bank details</Link></Button>
    </div>
  );
}
